module.exports = __webpack_public_path__ + "img/ic_memo_man.3819c20e.svg";